import React from 'react'
import PropTypes from 'prop-types'
import classes from 'classnames'

import { translate, utils } from 'parking-react-common'

import { toInteger, map, isPlainObject } from 'lodash'

import { ui } from '../redux'

import { Row, Column } from '../components/Grid'
import FormGroup from '../components/FormGroup'


const NumberDurationComponent = ({  input, meta, description, t, size, label, isHorizontal }) => {
    const { name, value, onChange } = input
    const { error } = meta

    const { numberTimeValue,  durationFormat } = value

    return (
        <FormGroup
            name={ name }
            error={ error }
            label={ label }
            description={ description }
            isHorizontal={ isHorizontal }
        >
            <Row>
                <Column span={ 6 } size={ ui.SIZE.medium }>
                    <input
                        id={ name }
                        className={ classes('form-control', `input-${size}`) }
                        placeholder={ t('Number value') }
                        onChange={
                            (event) => onChange({
                                numberTimeValue: toInteger(event.target.value),
                                durationFormat
                            })
                        }
                        value={ numberTimeValue }
                    />
                </Column>
                <Column span={ 6 } size={ ui.SIZE.medium }>
                    <select
                        id={ name }
                        className={ classes('form-control', `input-${size}`) }
                        onChange={ (event) => onChange({
                            numberTimeValue,
                            durationFormat: event.target.value
                        })
                        }
                        value={ durationFormat }
                    >
                        { map(['minutes', 'hours', 'days'], (value) => (
                            <option key={ value } value={ value }>{ t(value) }</option>
                        )) }
                    </select>
                </Column>
            </Row>
        </FormGroup>
    )
}

NumberDurationComponent.propTypes = {
    input        : PropTypes.object,
    meta         : PropTypes.object,
    label        : PropTypes.string,
    description  : PropTypes.string,
    size         : PropTypes.string,
    isHorizontal : PropTypes.bool
}

NumberDurationComponent.defaultProps = {
    isHorizontal: false
}

export const NumberDurationField = translate()(NumberDurationComponent)

//
// FIELD UTILS

export const formatNumberDurationField = (value) => {
    if (isPlainObject(value)) {
        return value
    }

    const { numberTimeValue, durationFormat } = utils.timeToNumberDurationFormat(value)
    const normalizedValues = utils.normalizeNumberDurationFormat(numberTimeValue, durationFormat)
    const { normalizedNumberTimeValue, normalizedDurationFormat } = normalizedValues

    return {
        numberTimeValue : normalizedNumberTimeValue,
        durationFormat  : normalizedDurationFormat
    }
}


export const parseNumberDurationField = (value) => {
    const { numberTimeValue, durationFormat } = value

    const normalizedValues = utils.normalizeNumberDurationFormat(numberTimeValue, durationFormat)
    const { normalizedNumberTimeValue, normalizedDurationFormat } = normalizedValues

    if (!normalizedNumberTimeValue) {
        return {
            numberTimeValue: '',
            durationFormat
        }
    }

    return utils.formatTime(normalizedNumberTimeValue, normalizedDurationFormat)
}
